import { render } from "./BackerCenterUpdateFeedEmptyState.vue?vue&type=template&id=eb34d40e"
import script from "./BackerCenterUpdateFeedEmptyState.vue?vue&type=script&lang=js"
export * from "./BackerCenterUpdateFeedEmptyState.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__